import Enum from 'enum';

export const enum DiagnosesTypeEnum {
    Tongue = 10001,
    Face = 10002,
    Taking = 10003,
    Lung = 10005,
    Phy = 10004,
    Health = 10006,
    Dialectic = 10007,
    Weigher = 10008,
    Four = 10009
}

export enum DiagnosesType2Enum {
    pulse = 10003,
    tongue = 10001,
    physique = 10004,
    lung = 10005,
    height = 10008,
    four = 10009,
}

export const StatusOptionsEnum = new Enum({
    '0': '禁用',
    '1': '启用',
});

export enum StatusEnum {
    '禁用',
    '启用',
}